import type {
	ChatBubbleVariant,
	ChatWidgetButtonVariant,
	RadiusVariant,
	SpaceVariant,
} from '@atlassian/csm-widget-ui-components/types';

export const handleWidgetRadiusType = (radius: string): RadiusVariant => {
	switch (radius) {
		case 'ROUNDED':
			return 'rounded';
		case 'SHARP':
			return 'sharp';
		case 'NORMAL':
		default:
			return 'normal';
	}
};

export const handleWidgetSpaceType = (space: string): SpaceVariant => {
	switch (space) {
		case 'COSY':
			return 'cosy';
		case 'GENEROUS':
			return 'generous';
		case 'COMFORTABLE':
		default:
			return 'comfortable';
	}
};

export const handleWidgetPosition = (position?: any): any => {
	switch (position) {
		case 'CENTER':
			return 'CENTER';
		case 'CORNER':
		default:
			return 'CORNER';
	}
};

export const handleChatBubbleVariant = (variant: string): ChatBubbleVariant => {
	switch (variant) {
		case 'LIGHT':
			return 'light';
		case 'DARK':
			return 'dark';
		case 'VIBRANT':
			return 'vibrant';
		case 'DEFAULT':
		default:
			return 'default';
	}
};

export const handleWidgetButtonVariant = (variant: string): ChatWidgetButtonVariant => {
	switch (variant) {
		case 'LIGHT':
			return 'light';
		case 'DARK':
			return 'dark';
		case 'VIBRANT':
			return 'vibrant';
		case 'DEFAULT':
		default:
			return 'dark';
	}
};
